import type { HelpFile } from '../../types/help'
import { TypeValuesViewTestIds } from '../../../testids/TypeValuesViewTestIds'

export const typeValuesViewHelp: HelpFile = {
  docPage: '/docs/admin/types',
  texts: {
    [TypeValuesViewTestIds.typeValuesSearch]:
      'Filter rows across every group by code or translated label. Groups with no matching rows are hidden; matching rows stay visible inside their group.',
    [TypeValuesViewTestIds.typeValuesNoResults]:
      'No rows in this type table match the current search. Clear the search to see every group again.',
    [TypeValuesViewTestIds.colIcon]: 'Optional icon shown next to the value in pickers and badges.',
    [TypeValuesViewTestIds.colCode]: null,
    [TypeValuesViewTestIds.colUsage]: 'How many entities currently reference this value. Click to see the references.',
    [TypeValuesViewTestIds.colActive]: null,
    [TypeValuesViewTestIds.colActions]: null,
  },
}
